import { useState } from 'react'
import { Dialog, Popover } from '@headlessui/react'
import {
  // ArrowPathIcon,
  Bars3Icon,
  // ChartPieIcon,
  // CursorArrowRaysIcon,
  // FingerPrintIcon,
  // SquaresPlusIcon,
  XMarkIcon,
} from '@heroicons/react/24/outline'
// import { ChevronDownIcon, 
//   // PhoneIcon, PlayCircleIcon 
// } from '@heroicons/react/20/solid'
import CustomSVG from '../assets/svg/CustomSvg'



// const projects = [
//   { name: 'Residential Projects', href: "https://wa.link/257thi"},
//   { name: 'Commercial Projects', href: "https://wa.link/66necp"}
// ]

// const floors = [
//   { name: '2BHK Listings', href:"/coming-soon"},
//   { name: '3BHK Listings', href:"/coming-soon"},
//   { name: '4BHK Listings', href:"/coming-soon"},
//   { name: 'View All Listings', href:"/coming-soon"},
// ]

// const more = [
//   { name: 'HSVP auction', href: "/coming-soon"},
//   { name: 'Blogs', href: "/#blog"},
//   { name: 'Careers', href: "/coming-soon"},
// ]




function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

const handleLocationSuccess = () => {
  // Push the event to the dataLayer
  window.dataLayer.push({
      event: 'mapsOpenSuccess',
      officeLocation: 'success'
  })}

export default function TempNavbar() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)
  const [listingIsShowing, setListIsShowing] = useState(false)
  const [projectIsShowing, setProjIsShowing] = useState(false)
  const [moreIsShowing, setMoreIsShowing] = useState(false)


  return (
    <header className="bg-white sticky top-0 z-10 shadow-md lg:px-4">

{/* desktop view navbar level 01 */}
    <nav className='lg:px-4 bg-nav-level01 h-[65px] max-sm:h-[35px] max-lg:h-[45px] mx-auto max-lg:justify-center flex items-center justify-between text-[#DEDDEB] max-md:text-[16px] text-[13px] underline underline-offset-2 font-spartan max-w-7xl relative z-[10]'>
      <div className='flex max-lg:justify-around w-[-webkit-fill-available] max-sm:gap-[0px] gap-[19px] max-lg:mx-[5rem] max-md:mx-[3rem] max-md:mx-[3rem] max-sm:mx-[0.5rem]'>
      <div className='vertical-nav-line max-lg:hidden'/>  
        <div className='flex gap-[6px] items-center'>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"
            className="w-[14px] h-[14] max-md:w-[14px] max-md:h-[14px] max-md:viewport-h-[14px] max-md:viewport-w-[14px]">
            <g clipPath="url(#clip0_374_172)">
              <path d="M2.85171 9.30626C4.23257 10.9569 5.89481 12.2565 7.79204 13.1761C8.51437 13.5184 9.48039 13.9246 10.5566 13.9942C10.6234 13.9971 10.6872 14 10.7539 14C11.4762 14 12.0564 13.7505 12.5293 13.237C12.5322 13.2341 12.538 13.2283 12.5409 13.2225C12.7092 13.0195 12.9006 12.8367 13.1008 12.6424C13.2371 12.5118 13.3764 12.3755 13.5098 12.2362C14.1277 11.5922 14.1277 10.7741 13.504 10.1504L11.7605 8.40696C11.4646 8.09946 11.1107 7.93701 10.7394 7.93701C10.3681 7.93701 10.0113 8.09946 9.70667 8.40406L8.66813 9.4426C8.57239 9.38748 8.47376 9.33817 8.38093 9.29175C8.26489 9.23373 8.15756 9.17862 8.06183 9.1177C7.11612 8.5172 6.25743 7.73394 5.43646 6.72731C5.02163 6.20224 4.74314 5.76129 4.54877 5.31165C4.82146 5.06506 5.07675 4.80688 5.32333 4.5545C5.41036 4.46457 5.50028 4.37464 5.59021 4.28471C5.90352 3.9714 6.07177 3.60879 6.07177 3.24036C6.07177 2.87194 5.90642 2.50932 5.59021 2.19602L4.72573 1.33154C4.6242 1.23 4.52846 1.13137 4.42983 1.02984C4.23837 0.832574 4.0382 0.629507 3.84094 0.446747C3.54214 0.15375 3.19113 0 2.8198 0C2.45138 0 2.09747 0.153751 1.78706 0.449648L0.702107 1.5346C0.307578 1.92913 0.0842043 2.40779 0.037789 2.96187C-0.0173291 3.6552 0.110313 4.39204 0.441022 5.28264C0.948688 6.66059 1.71454 7.93991 2.85171 9.30626ZM0.745622 3.02279C0.780433 2.63697 0.928382 2.31496 1.20687 2.03647L2.28603 0.957315C2.45428 0.794861 2.63994 0.710734 2.8198 0.710734C2.99676 0.710734 3.17662 0.794861 3.34197 0.963116C3.53634 1.14298 3.7191 1.33154 3.91636 1.5317C4.015 1.63324 4.11653 1.73477 4.21806 1.8392L5.08255 2.70369C5.26241 2.88355 5.35524 3.06631 5.35524 3.24617C5.35524 3.42603 5.26241 3.60879 5.08255 3.78865C4.99262 3.87857 4.90269 3.97141 4.81276 4.06133C4.54297 4.33402 4.29059 4.59221 4.0121 4.83879C4.00629 4.84459 4.00339 4.84749 3.99759 4.85329C3.75681 5.09407 3.79452 5.32325 3.85254 5.49731C3.85544 5.50601 3.85835 5.51181 3.86125 5.52051C4.08462 6.05719 4.39502 6.56776 4.87948 7.17696C5.74977 8.25031 6.66647 9.08288 7.676 9.724C7.80074 9.80522 7.93418 9.86904 8.05892 9.93286C8.17496 9.99088 8.2823 10.046 8.37803 10.1069C8.38963 10.1127 8.39834 10.1185 8.40994 10.1243C8.50567 10.1736 8.5985 10.1969 8.69133 10.1969C8.92341 10.1969 9.07426 10.0489 9.12358 9.99959L10.2085 8.91463C10.3768 8.74637 10.5595 8.65644 10.7394 8.65644C10.9599 8.65644 11.1397 8.79279 11.2529 8.91463L13.0021 10.661C13.3503 11.0091 13.3474 11.3862 12.9934 11.7547C12.8716 11.8852 12.744 12.0099 12.6076 12.1405C12.4046 12.3378 12.1928 12.5408 12.0013 12.77C11.6677 13.1297 11.2703 13.298 10.7568 13.298C10.7075 13.298 10.6553 13.2951 10.606 13.2922C9.65445 13.2312 8.76966 12.8599 8.10534 12.5437C6.30095 11.6705 4.71703 10.4318 3.40289 8.85951C2.32084 7.55698 1.5927 6.34438 1.11114 5.04476C0.812344 4.247 0.699206 3.60588 0.745622 3.02279Z" fill="#DEDDEB"/>
            </g>
            <defs>
              <clipPath id="clip0_374_172">
                <rect width="14" height="14" fill="white"/>
              </clipPath>
            </defs>
          </svg>
          <a target="_blank" rel='noreferrer' href='tel:+919910109700' className='max-lg:font-bold'>+91-9910109700</a>
        </div>
      <div className='vertical-nav-line'/>
        <div className='flex gap-[6px] items-center max-lg:hidden'>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none"
          className="w-[14px] h-[14] max-md:w-[12px] max-md:h-[11px] max-md:viewport-h-[11px] max-md:viewport-w-[11px]">
          <path d="M14.5 0H1.50001C0.672854 0 0 0.672853 0 1.50001V10.5C0 11.3271 0.672854 12 1.50001 12H14.5C15.3271 12 16 11.3271 16 10.5V1.50001C16 0.672853 15.3271 0 14.5 0ZM14.5 0.999994C14.5679 0.999994 14.6325 1.01409 14.6916 1.0387L8 6.83838L1.30833 1.0387C1.36742 1.01412 1.43204 0.999994 1.49998 0.999994H14.5ZM14.5 11H1.50001C1.22414 11 0.999996 10.7759 0.999996 10.5V2.09521L7.67236 7.87792C7.76661 7.95944 7.8833 7.99999 8 7.99999C8.1167 7.99999 8.23339 7.95948 8.32764 7.87792L15 2.09521V10.5C15 10.7759 14.7759 11 14.5 11Z" fill="#DEDDEB"/>
          </svg>
          <a target="_blank" rel='noreferrer' href='mailto:sales@acmespaces.com'>sales@acmespaces.com</a>
        </div>
      <div className='vertical-nav-line max-lg:hidden'/>
        <div className='flex gap-[6px] items-center'>
        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="14" viewBox="0 0 12 14" fill="none"
        className="w-[14px] h-[14] max-md:w-[14px] max-md:h-[14px] max-md:viewport-h-[14px] max-md:viewport-w-[14px]">
          <path d="M6 0.733252C7.48521 0.733252 8.90959 1.32325 9.9598 2.37345C11.01 3.42366 11.6 4.84804 11.6 6.33325C11.6 8.23182 10.564 9.81348 9.42012 10.9828C8.84971 11.5592 8.2275 12.0819 7.56136 12.5443L7.28072 12.7354L7.15249 12.8206L6.90774 12.9764L6.69061 13.1089L6.41859 13.2672C6.29094 13.3395 6.14673 13.3775 6 13.3775C5.85325 13.3775 5.70902 13.3395 5.58135 13.2671L5.3101 13.1093L4.97198 12.9013L4.84998 12.8218L4.58088 12.6427C4.58045 12.6424 4.58003 12.6421 4.5796 12.6418C3.86067 12.1551 3.1909 11.5994 2.5798 10.9827C1.43589 9.81263 0.4 8.2317 0.4 6.33325C0.4 4.84804 0.989998 3.42366 2.0402 2.37345C3.09041 1.32325 4.51479 0.733252 6 0.733252ZM6 3.93325C5.68483 3.93325 5.37274 3.99533 5.08156 4.11594C4.79038 4.23655 4.5258 4.41333 4.30294 4.6362C4.08008 4.85906 3.9033 5.12363 3.78269 5.41481C3.66208 5.70599 3.6 6.01808 3.6 6.33325C3.6 6.64842 3.66208 6.96051 3.78269 7.25169C3.9033 7.54287 4.08008 7.80745 4.30294 8.03031C4.5258 8.25317 4.79038 8.42995 5.08156 8.55056C5.37274 8.67118 5.68483 8.73325 6 8.73325C6.63652 8.73325 7.24697 8.4804 7.69706 8.03031C8.14714 7.58022 8.4 6.96977 8.4 6.33325C8.4 5.69673 8.14714 5.08628 7.69706 4.6362C7.24697 4.18611 6.63652 3.93325 6 3.93325Z" stroke="#DEDDEB" strokeWidth="0.8"/>
        </svg>
          <a target="_blank" rel='noreferrer' onClick={handleLocationSuccess} id="WS_Office_header" className='lg:hidden font-bold' href='https://maps.app.goo.gl/pFn9AkFFPzVLsWqb7'>Omaxe World Street</a>
          <a target="_blank" rel='noreferrer' onClick={handleLocationSuccess} id="WS_Office_header" className='max-lg:hidden' href='https://maps.app.goo.gl/pFn9AkFFPzVLsWqb7'>OMAXE World Street, Faridabad</a>
        </div>
      </div>
      
      <div className='flex gap-[16px] items-center max-lg:hidden'>
      <div className='vertical-nav-line'/>
        <a href='https://www.facebook.com/acmespaces1/' target="_blank" rel="noreferrer">
          <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
          <path d="M6.23896 16V8.70218H8.68755L9.05491 5.85725H6.23896V4.04118C6.23896 3.21776 6.46668 2.65661 7.64879 2.65661L9.15402 2.65599V0.111384C8.89371 0.0775563 8.00017 0 6.96017 0C4.78849 0 3.30172 1.32557 3.30172 3.75942V5.85725H0.845703V8.70218H3.30172V16H6.23896Z" fill="#DEDDEB"/>
          </svg>
        </a>
      <div className='vertical-nav-line'/>
        <a target="_blank" rel="noreferrer" href='https://www.instagram.com/acmespaces/'>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
          <g clipPath="url(#clip0_371_166)">
          <path d="M15.9836 4.70404C15.9461 3.8539 15.8086 3.26944 15.6117 2.76299C15.4085 2.22541 15.096 1.74411 14.6865 1.34401C14.2864 0.937683 13.8019 0.621948 13.2705 0.421957C12.7612 0.22502 12.1797 0.0875415 11.3296 0.0500586C10.4731 0.00940124 10.2012 0 8.02891 0C5.85661 0 5.5847 0.00940124 4.73139 0.0468842C3.88125 0.0843671 3.29678 0.221967 2.79046 0.418783C2.25275 0.621948 1.77146 0.934509 1.37136 1.34401C0.965027 1.74411 0.649413 2.22858 0.449301 2.75994C0.252363 3.26944 0.114885 3.85073 0.0774023 4.70087C0.036745 5.55736 0.0273438 5.82926 0.0273438 8.00156C0.0273438 10.1739 0.036745 10.4458 0.0742279 11.2991C0.111711 12.1492 0.249311 12.7337 0.446249 13.2401C0.649413 13.7777 0.965027 14.259 1.37136 14.6591C1.77146 15.0654 2.25593 15.3812 2.78728 15.5812C3.29678 15.7781 3.87807 15.9156 4.72834 15.9531C5.58153 15.9907 5.85356 15.9999 8.02585 15.9999C10.1982 15.9999 10.4701 15.9907 11.3234 15.9531C12.1735 15.9156 12.758 15.7781 13.2643 15.5812C14.3396 15.1654 15.1897 14.3153 15.6055 13.2401C15.8023 12.7306 15.9399 12.1492 15.9774 11.2991C16.0148 10.4458 16.0242 10.1739 16.0242 8.00156C16.0242 5.82926 16.0211 5.55736 15.9836 4.70404ZM14.5428 11.2366C14.5083 12.018 14.3771 12.4399 14.2677 12.7212C13.9988 13.4183 13.4456 13.9715 12.7486 14.2403C12.4673 14.3497 12.0423 14.481 11.2639 14.5153C10.42 14.5529 10.1669 14.5622 8.03208 14.5622C5.89726 14.5622 5.64099 14.5529 4.80013 14.5153C4.01872 14.481 3.59677 14.3497 3.31546 14.2403C2.96859 14.1121 2.65286 13.909 2.39658 13.6433C2.1309 13.3838 1.92774 13.0713 1.79954 12.7244C1.69014 12.4431 1.55889 12.018 1.52458 11.2397C1.48698 10.3958 1.4777 10.1426 1.4777 8.00779C1.4777 5.87297 1.48698 5.6167 1.52458 4.77596C1.55889 3.99455 1.69014 3.5726 1.79954 3.29129C1.92774 2.9443 2.1309 2.62869 2.39976 2.37229C2.65908 2.10661 2.97164 1.90345 3.31864 1.77537C3.59994 1.66597 4.02507 1.53472 4.8033 1.50029C5.64722 1.46281 5.90044 1.45341 8.03513 1.45341C10.1731 1.45341 10.4262 1.46281 11.2671 1.50029C12.0485 1.53472 12.4704 1.66597 12.7518 1.77537C13.0986 1.90345 13.4144 2.10661 13.6706 2.37229C13.9363 2.63174 14.1395 2.9443 14.2677 3.29129C14.3771 3.5726 14.5083 3.99761 14.5428 4.77596C14.5802 5.61987 14.5896 5.87297 14.5896 8.00779C14.5896 10.1426 14.5802 10.3927 14.5428 11.2366Z" fill="#DEDDEB"/>
          <path d="M8.0301 3.89136C5.76098 3.89136 3.91992 5.73229 3.91992 8.00153C3.91992 10.2708 5.76098 12.1117 8.0301 12.1117C10.2993 12.1117 12.1403 10.2708 12.1403 8.00153C12.1403 5.73229 10.2993 3.89136 8.0301 3.89136ZM8.0301 10.6677C6.55801 10.6677 5.36393 9.47375 5.36393 8.00153C5.36393 6.52932 6.55801 5.33536 8.0301 5.33536C9.50231 5.33536 10.6963 6.52932 10.6963 8.00153C10.6963 9.47375 9.50231 10.6677 8.0301 10.6677Z" fill="#DEDDEB"/>
          <path d="M13.2629 3.72883C13.2629 4.25871 12.8333 4.68836 12.3033 4.68836C11.7734 4.68836 11.3438 4.25871 11.3438 3.72883C11.3438 3.19881 11.7734 2.76929 12.3033 2.76929C12.8333 2.76929 13.2629 3.19881 13.2629 3.72883Z" fill="#DEDDEB"/>
          </g>
          <defs>
          <clipPath id="clip0_371_166">
          <rect width="16" height="16" fill="white"/>
          </clipPath>
          </defs>
          </svg>
        </a>
      <div className='vertical-nav-line'/>
        <a target="_blank" rel="noreferrer" href='https://www.linkedin.com/company/acmespaces'>
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M14.7197 0.00143501H1.36997C1.1979 -0.0066248 1.02593 0.0193248 0.8639 0.0778135C0.701874 0.136302 0.552978 0.22617 0.42572 0.342267C0.298473 0.458374 0.195366 0.598441 0.122317 0.754437C0.049269 0.910444 0.00769982 1.07932 0 1.25141V14.6311C0.0100798 14.9912 0.157656 15.3339 0.41242 15.5886C0.667184 15.8434 1.00982 15.991 1.36997 16.0011H14.7197C15.0698 15.9855 15.3998 15.8333 15.6391 15.5772C15.8784 15.3211 16.0078 14.9815 15.9996 14.6311V1.25141C16.0025 1.08391 15.9711 0.917604 15.9074 0.762668C15.8437 0.607741 15.749 0.467454 15.6291 0.350407C15.5093 0.23337 15.3668 0.142052 15.2105 0.0820434C15.0541 0.0220348 14.8871 -0.00539483 14.7197 0.00143501ZM4.99988 13.3412H2.66994V6.21132H4.99988V13.3412ZM3.88991 5.13132C3.72732 5.13699 3.56532 5.10897 3.41408 5.04903C3.26283 4.98909 3.12562 4.89852 3.01106 4.78302C2.89649 4.66751 2.80705 4.52956 2.74835 4.37783C2.68964 4.22611 2.66295 4.06388 2.66994 3.90135C2.66275 3.73705 2.68998 3.57307 2.74989 3.41993C2.8098 3.26677 2.90105 3.12783 3.0178 3.01203C3.13456 2.89621 3.27422 2.80608 3.42785 2.74742C3.58149 2.68875 3.74568 2.66285 3.90991 2.67137C4.0725 2.66571 4.2345 2.69372 4.38574 2.75366C4.53699 2.8136 4.6742 2.90417 4.78876 3.01968C4.90333 3.13518 4.99278 3.27313 5.05147 3.42486C5.11018 3.57658 5.13687 3.73881 5.12988 3.90135C5.13707 4.06564 5.10984 4.22962 5.04993 4.38276C4.99002 4.53592 4.89877 4.67486 4.78202 4.79067C4.66526 4.90648 4.5256 4.99661 4.37197 5.05527C4.21833 5.11394 4.05414 5.13984 3.88991 5.13132ZM13.3397 13.3412H10.9997V9.44125C10.9997 8.51127 10.6698 7.87128 9.83977 7.87128C9.58198 7.87348 9.33108 7.95538 9.12169 8.10578C8.91219 8.25617 8.7544 8.46767 8.6698 8.71126C8.6048 8.89386 8.5776 9.08776 8.5898 9.28125V13.3412H6.28986V6.21132H8.5898V7.2113C8.7943 6.83561 9.09859 6.52382 9.46918 6.31022C9.83977 6.09672 10.2622 5.98981 10.6898 6.0013C12.1997 6.0013 13.3397 7.0013 13.3397 9.13125V13.3412Z" fill="#DEDDEB"/>
        </svg>



          {/* <svg xmlns="http://www.w3.org/2000/svg" width="16" height="12" viewBox="0 0 16 12" fill="none">
          <path d="M6.4 8L10.552 5.6L6.4 3.2V8ZM15.648 1.736C15.752 2.112 15.824 2.616 15.872 3.256C15.928 3.896 15.952 4.448 15.952 4.928L16 5.6C16 7.352 15.872 8.64 15.648 9.464C15.448 10.184 14.984 10.648 14.264 10.848C13.888 10.952 13.2 11.024 12.144 11.072C11.104 11.128 10.152 11.152 9.272 11.152L8 11.2C4.648 11.2 2.56 11.072 1.736 10.848C1.016 10.648 0.552 10.184 0.352 9.464C0.248 9.088 0.176 8.584 0.128 7.944C0.0720001 7.304 0.048 6.752 0.048 6.272L0 5.6C0 3.848 0.128 2.56 0.352 1.736C0.552 1.016 1.016 0.552 1.736 0.352C2.112 0.248 2.8 0.176 3.856 0.128C4.896 0.0719999 5.848 0.048 6.728 0.048L8 0C11.352 0 13.44 0.128 14.264 0.352C14.984 0.552 15.448 1.016 15.648 1.736Z" fill="#DEDDEB"/>
          </svg> */}
        </a>
      <div className='vertical-nav-line'/>
      </div>
    </nav>





    {/* DESKTOP VIEW NAVBAR */}
      <nav className="mx-auto flex max-w-7xl items-center justify-between z-[10] relative max-lg:mx-[1em] /*p-6 lg:px-8*/" aria-label="Global">
        <div className="flex lg:flex-1">
          <a href="/" className="w-[219px] h-[80px]">
            <span className="sr-only">AcmeSpaces</span>
            <img className="/*h-8*/ xl:w-auto w-[90%] " src="https://ik.imagekit.io/AcmeSpaces/logo/HeadrLogo.png" alt="" />
          </a>
        </div>

        {/* nav bar hamburgur button */}
        <div className="flex lg:hidden">
          <button
            type="button"
            className="/*-m-2.5*/ inline-flex items-center justify-center rounded-md p-2.5 text-[#13293D]"
            onClick={() => setMobileMenuOpen(true)}
          >
            <span className="sr-only">Open main menu</span>
            <Bars3Icon className="h-6 w-6" aria-hidden="true" />
          </button>
        </div>


        <Popover.Group className="hidden max-xl:items-center lg:flex lg:gap-x-[25px] xl:gap-x-[40px] pt-[6px]">
          
        {/* ----- BUILDER FLOOR LISTING ----- */}
        
        {/* <Popover className="relative"
          onMouseEnter={() => {
            setListIsShowing(true);
            setMoreIsShowing(false);
            setProjIsShowing(false);
          }}
          >
            <Popover className="flex items-center font-spartan gap-x-1 xl:text-[22px] text-[20px]  font-normal decoration-black
            group transition-all duration-300 ease-in-out" 
            style={{cursor:"pointer"}}>
              <span className='bg-left-bottom bg-gradient-to-r from-[#6495ED] to-[#6495ED] bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out'>Builder Floor Listings</span>
              <ChevronDownIcon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
            </Popover>

            <Transition
              as={Fragment}
              enter="transition ease-out duration-200"
              enterFrom="opacity-0 translate-y-1"
              enterTo="opacity-100 translate-y-0"
              leave="transition ease-in duration-150"
              leaveFrom="opacity-100 translate-y-0"
              leaveTo="opacity-0 translate-y-1"

              show={listingIsShowing}
              onMouseLeave={() => setListIsShowing(false)}
            >
              <Popover.Panel className="absolute top-full z-10 mt-3 w-screen max-w-48 overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5">
                <div className="p-4">
                  {floors.map((item) => (
                    <div
                      key={item.name}
                      className="group relative flex items-center gap-x-6 rounded-lg p-4 text-base leading-6 hover:bg-gray-50"
                    >
                      <div className="flex-auto">
                        <a href={item.href} className="relative block text-gray-900 
                        group transition-all duration-300 ease-in-out font-montserrat">
                          <span className='group-hover:visible invisible absolute ml-[-0.75em] group-hover:opacity-100 opacity-0 transition-opacity duration-300 text-black'>‣</span><span className='bg-left-bottom bg-gradient-to-r from-[#6495ED] to-[#6495ED] bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out'>{item.name}</span> 
                          <span className="absolute inset-0" />
                        </a>
                      </div>
                    </div>
                  ))}
                </div>
              </Popover.Panel>
            </Transition>
          </Popover> */}

        {/* ----- PROJECTS ----- */}
        {/* <Popover className="relative"
        onMouseEnter={() => {
        setListIsShowing(false);
        setMoreIsShowing(false);
        setProjIsShowing(true);
        }}
        >
        <Popover className="flex items-center font-spartan gap-x-1 xl:text-[22px] text-[20px] font-normal decoration-black
        group transition-all duration-300 ease-in-out" 
        style={{cursor:"pointer"}}>
            <span className='bg-left-bottom bg-gradient-to-r from-[#6495ED] to-[#6495ED] bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out'>Projects</span>
            <ChevronDownIcon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
        </Popover>

        <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"

            show={projectIsShowing}
            onMouseLeave={() => setProjIsShowing(false)}
        >
            <Popover.Panel className="absolute top-full z-10 mt-3 w-screen max-w-60 overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5">
            <div className="p-4">
                {projects.map((item) => (
                <div
                    key={item.name}
                    className="group relative flex items-center gap-x-6 rounded-lg p-4 text-base leading-6 hover:bg-gray-50"
                >
                    <div className="flex-auto">
                    <a href={item.href} target="_blank" rel="noreferrer" className="relative block text-gray-900 
                    group transition-all duration-300 ease-in-out font-montserrat">
                        <span className='group-hover:visible invisible absolute ml-[-0.75em] group-hover:opacity-100 opacity-0 transition-opacity duration-300 text-black'>‣</span><span className='bg-left-bottom bg-gradient-to-r from-[#6495ED] to-[#6495ED] bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out'>{item.name}</span> 
                        <span className="absolute inset-0" />
                    </a>
                    </div>
                </div>
                ))}
            </div>
            </Popover.Panel>
        </Transition>
        </Popover> */}
          <a href="/#about" className="flex font-spartan gap-x-1 xl:text-[22px] text-[20px] font-normal decoration-black
          group transition-all duration-300 ease-in-out">
            <span className='bg-left-bottom bg-gradient-to-r from-[#6495ED] to-[#6495ED] bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out'>About</span>
          </a>

          <a href="/#blog" className="flex font-spartan gap-x-1 xl:text-[22px] text-[20px] font-normal decoration-black
          group transition-all duration-300 ease-in-out">
            <span className='bg-left-bottom bg-gradient-to-r from-[#6495ED] to-[#6495ED] bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out'>Blogs</span>
          </a>

          <a href="/sell-your-property" className="flex font-spartan gap-x-1 xl:text-[22px] text-[20px] font-normal decoration-black
          group transition-all duration-300 ease-in-out">
            <span className='bg-left-bottom bg-gradient-to-r from-[#6495ED] to-[#6495ED] bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out'>Sell Your Property</span>
          </a>

          <a href="/careers" className="flex font-spartan gap-x-1 xl:text-[22px] text-[20px] font-normal decoration-black
          group transition-all duration-300 ease-in-out">
            <span className='bg-left-bottom bg-gradient-to-r from-[#6495ED] to-[#6495ED] bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out'>Careers</span>
          </a>


        {/* MORE */}
        {/* <Popover className="relative"
        onMouseEnter={() => {
        setListIsShowing(false);
        setMoreIsShowing(true);
        setProjIsShowing(false);
        }}
        >
                    <Popover className="flex items-center font-spartan gap-x-1 xl:text-[22px] text-[20px] font-normal decoration-black
        group transition-all duration-300 ease-in-out" 
        style={{cursor:"pointer"}}>
            <span className='bg-left-bottom bg-gradient-to-r from-[#6495ED] to-[#6495ED] bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out'>More</span>
            <ChevronDownIcon className="h-5 w-5 flex-none text-gray-400" aria-hidden="true" />
        </Popover>

        <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"

            show={moreIsShowing}
            onMouseLeave={() => setMoreIsShowing(false)}
        >
            <Popover.Panel className="absolute -left-8 top-full z-10 mt-3 w-screen max-w-48 overflow-hidden rounded-3xl bg-white shadow-lg ring-1 ring-gray-900/5">
            <div className="p-4">
                {more.map((item) => (
                <div
                    key={item.name}
                    className="group relative flex items-center gap-x-6 rounded-lg p-4 text-base leading-6 hover:bg-gray-50"
                >
                    <div className="flex-auto">
                    <a href={item.href} className="relative block text-gray-900 
                    group transition-all duration-300 ease-in-out font-montserrat">
                        <span className='group-hover:visible invisible absolute ml-[-0.75em] group-hover:opacity-100 opacity-0 transition-opacity duration-300 text-black'>‣</span><span className='bg-left-bottom bg-gradient-to-r from-[#6495ED] to-[#6495ED] bg-[length:0%_2px] bg-no-repeat group-hover:bg-[length:100%_2px] transition-all duration-500 ease-out'>{item.name}</span> 
                        <span className="absolute inset-0" />
                    </a>
                    </div>
                </div>
                ))}
            </div>
            </Popover.Panel>
        </Transition>
        </Popover> */}

        <div className="hidden lg:flex lg:flex-1 ">
          <a href="/contact" className="font-spartan xl:text-xl text-lg font-normal contact-btn-css">
            Contact Us
          </a>
        </div>
        </Popover.Group>
      </nav>


      {/* nav mob view */}

      <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
        <div className="fixed inset-0 z-10" />
        <Dialog.Panel className="fixed inset-y-0 right-0 z-10 w-full overflow-y-auto bg-white px-6 pb-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10 max-lg:top-[45px] max-sm:top-[35px]">
          <div className="flex items-center justify-between">
            <a href="/" className="w-[219px] h-[80px]">
              <span className="sr-only">AcmeSpaces</span>
              <img
                className="xl:w-auto w-[90%] -left-[0.5rem] relative "
                src="https://ik.imagekit.io/AcmeSpaces/logo/HeadrLogo.png"
                alt=""
              />
            </a>
            <button
              type="button"
              className="-m-2.5 rounded-md p-2.5 text-gray-700"
              onClick={() => setMobileMenuOpen(false)}
            >
              <span className="sr-only">Close menu</span>
              <XMarkIcon className="h-6 w-6" aria-hidden="true" />
            </button>
          </div>
          <div className="mt-6 flow-root">
            {/* <div className="-my-6 divide-y divide-gray-500/10"> */}
              <div className="space-y-2 pb-6">

              {/* <hr className='ul-mob-nav '/> */}

              {/* <hr className='ul-mob-nav '/> */}

                <a
                    onClick={() => setMobileMenuOpen(false)}
                    href="/#about"
                    className="ul-mob-nav -mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                    About
                </a>
              <hr className='ul-mob-nav '/>
                <a
                  onClick={() => setMobileMenuOpen(false)}
                  href="/#blog"
                  className="ul-mob-nav -mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Blogs
                </a>
              <hr className='ul-mob-nav '/>

                <a
                  onClick={() => setMobileMenuOpen(false)}
                  href="/sell-your-property"
                  className="ul-mob-nav -mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Sell Your Property
                </a>
              <hr className='ul-mob-nav '/>

                <a
                  onClick={() => setMobileMenuOpen(false)}
                  href="/careers"
                  className="ul-mob-nav -mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >
                  Careers
                </a>
              <hr className='ul-mob-nav '/>

              </div>
              <div className="/*py-6*/">
              <a 
              onClick={() => setMobileMenuOpen(false)}
              className='ul-mob-nav flex w-full items-center justify-between rounded-lg text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50 '
              href="/contact">
                Contact Us
              </a>
              </div>
            {/* </div> */}
          </div>
        </Dialog.Panel>
      </Dialog>
    </header>
  )
}
